import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp, fRef } from '../../utils/React.js';
import { ActionPresentation } from '../Action/ActionPresentation.js';
import { IconPresentation } from '../Icon/IconPresentation.js';
import { hostClass } from './IconLink.styles.js';

// Hack to get rid of forwardRefs
var Div = fRef(function (_a) {
  var ref = _a.ref,
    props = __rest(_a, ["ref"]);
  return /*#__PURE__*/React.createElement("div", Object.assign({}, props, {
    ref: ref
  }));
});
var IconLinkPresentation = fComp(function (_a) {
  var _cleanupClassObject, _cleanupClassObject2;
  var iconName = _a.iconName,
    icon = _a.icon,
    iconId = _a.iconId,
    lookProp = _a.look,
    directionProp = _a.hoverAnimation,
    loading = _a.loading,
    iconColorProp = _a.iconColor,
    iconVariant = _a.iconVariant,
    secondary = _a.secondary,
    inactive = _a.inactive,
    transform = _a.transform,
    disabled = _a.disabled,
    actionRef = _a.actionRef,
    innerRef = _a.innerRef,
    hasKeyboardFocus = _a.hasKeyboardFocus,
    hasMouseHover = _a.hasMouseHover,
    svgAttrs = _a.svgAttrs,
    children = _a.children,
    className = _a.className,
    htmlAttrs = _a.htmlAttrs,
    textEllipsis = _a.textEllipsis,
    clicked = _a.clicked,
    showBadge = _a.showBadge,
    badgeText = _a.badgeText,
    containerRef = _a.containerRef,
    inline = _a.inline,
    nonInteractive = _a.nonInteractive,
    horizontalAlignment = _a.horizontalAlignment,
    size = _a.size,
    otherProps = __rest(_a, ["iconName", "icon", "iconId", "look", "hoverAnimation", "loading", "iconColor", "iconVariant", "secondary", "inactive", "transform", "disabled", "actionRef", "innerRef", "hasKeyboardFocus", "hasMouseHover", "svgAttrs", "children", "className", "htmlAttrs", "textEllipsis", "clicked", "showBadge", "badgeText", "containerRef", "inline", "nonInteractive", "horizontalAlignment", "size"]);
  var iconColor = iconColorProp || disabled && "disabled" || secondary && "secondary" || "default";
  var textColor = disabled && "disabled" || secondary && "secondary" || inactive && "inactive" || "primary";
  var look = lookProp || (iconName || icon ? "left" : "no-icon");
  var direction = "hover".concat(directionProp ? "-".concat(directionProp) : "");
  return /*#__PURE__*/React.createElement(Host, {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__size-").concat(size), size), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__text-ellipsis"), textEllipsis), _defineProperty(_cleanupClassObject, "".concat(hostClass, "-inline"), inline), _defineProperty(_cleanupClassObject, "".concat(hostClass, "-inline__with-label"), inline && children), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "text-align-").concat(horizontalAlignment), horizontalAlignment), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "margin-align-").concat(horizontalAlignment), horizontalAlignment), _cleanupClassObject)),
    ref: containerRef
  }, /*#__PURE__*/React.createElement(ActionPresentation, Object.assign({
    htmlAttrs: htmlAttrs,
    disabled: disabled,
    loading: loading,
    nonInteractive: nonInteractive,
    ref: actionRef
  }, otherProps), /*#__PURE__*/React.createElement(Div, {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__").concat(look), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__").concat(textColor), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-wrapper"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__").concat(direction), !disabled && !nonInteractive && (hasMouseHover || hasKeyboardFocus || clicked)), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__focus"), !disabled && hasKeyboardFocus), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__hidden"), loading), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__badge-").concat(badgeText === null || badgeText === void 0 ? void 0 : badgeText.length, "-symbols"), (badgeText === null || badgeText === void 0 ? void 0 : badgeText.length) >= 1), _cleanupClassObject2)),
    ref: innerRef
  }, look !== "no-icon" && /*#__PURE__*/React.createElement(IconPresentation, Object.assign({}, svgAttrs, {
    id: iconId,
    noMargin: true,
    name: iconName,
    icon: icon,
    hover: !disabled && (hasMouseHover || hasKeyboardFocus),
    color: iconColor,
    variant: iconVariant,
    size: size === "legacy" ? "legacy-reduced" : "small",
    "aria-hidden": true,
    title: (htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.title) || "",
    transform: transform,
    showBadge: showBadge,
    badgeText: badgeText
  })), /*#__PURE__*/React.createElement("span", {
    className: "".concat(hostClass, "-label")
  }, children))));
});
IconLinkPresentation.displayName = "IconLinkPresentation";

export { IconLinkPresentation };
